import { logger } from "@/util/logger";

export namespace FileUtils {
  export const isValidFile = (file: File, maxSizeMB: number = 2, allowedExtensions: string[] = [".pdf"]): boolean => {
    const isAllowedExtension = isValidExtension(file, allowedExtensions);
    const isValidSize = isFileSizeValid(file, maxSizeMB);

    return isAllowedExtension && isValidSize;
  };

  export const isFileSizeValid = (file: File, maxSizeMB: number = 2): boolean => {
    const MAX_SIZE_BYTES = maxSizeMB * 1024 * 1024;
    return file.size <= MAX_SIZE_BYTES;
  };

  export const isValidExtension = (file: File, allowedExtensions: string[]): boolean => {
    return allowedExtensions.some((ext) => file.name.toLowerCase().endsWith(ext));
  };

  export const isSecurePDF = async (file: File): Promise<boolean> => {
    try {
      if (!file.name.toLowerCase().endsWith(".pdf")) {
        return false;
      }

      const arrayBuffer = await file.arrayBuffer();
      const uint8Array = new Uint8Array(arrayBuffer);

      const pdfContent = new TextDecoder("latin1").decode(uint8Array);

      const encryptionPatterns = ["/Encrypt", "/Filter /Standard", "/Filter/Standard", "/O (", "/U ("];

      return encryptionPatterns.some((pattern) => pdfContent.includes(pattern));
    } catch {
      return false;
    }
  };

  export const handleFileDownload = async (fileUrl?: string, name?: string) => {
    if (!fileUrl) {
      return;
    }

    try {
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();

      const filename = `${name}_resume.pdf`;

      const blobUrl = window.URL.createObjectURL(blob);
      handleDownload(blobUrl, filename);
    } catch (error) {
      logger.error("Download failed", { error });
      throw error;
    }
  };

  export const handleDownload = (url: string, filename: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
}
